// extracted by mini-css-extract-plugin
export var bodySections = "_dh-8";
export var gray = "_dh-7";
export var green = "_dh-4";
export var iconContainer = "_dh-9";
export var iconWidgetContainer = "_dh-1";
export var phoneIcon = "_dh-2";
export var red = "_dh-5";
export var statusDot = "_dh-3";
export var widgetContainer = "_dh-0";
export var yellow = "_dh-6";